import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import useTournamentDetails from '@/hooks/useTournamentDetails';
import { useState } from 'react';
import SearchablePlayerSelect from './SearchablePlayerSelect';

const SyncPlayerModal = ({
  onSubmit,
  onClose,
  title,
  tournamentId,
}: {
  onSubmit: (playerId: string) => void;
  onClose: () => void;
  title: string;
  tournamentId: string;
}) => {
  const { players } = useTournamentDetails(tournamentId);
  const [selectedPlayer, setSelectedPlayer] = useState<string | null>(null);

  const handleSubmit = () => {
    if (!selectedPlayer) {
      return;
    }

    const player = players?.players?.find((player) => player.userId === selectedPlayer);
    if (!player) {
      return;
    }

    onSubmit(player.userId);
  };

  return (
    <Modal isOpen toggle={onClose} id="sync-player-modal" className="modal-md" centered>
      <ModalHeader toggle={onClose}>{title}</ModalHeader>
      <ModalBody className="d-flex flex-column gap-4">
        <div>
          <p className="mb-2">Select Player to Sync</p>
          <SearchablePlayerSelect
            players={players?.players}
            selectedPlayerId={selectedPlayer}
            onPlayerSelect={setSelectedPlayer}
            placeholder="Search for a player to sync..."
          />
        </div>

        <div className="alert alert-info" role="alert">
          <strong>Info:</strong> This will synchronize the player's seat data with the table cache and leaderboard. If
          the player has no stack, they will be automatically eliminated.
        </div>

        <Button disabled={!selectedPlayer} color="primary" onClick={handleSubmit}>
          Sync Player
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default SyncPlayerModal;
